export function formatTime(time: string | number) {
  if (typeof time === 'number') {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);

    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');

    let formattedTime = `${formattedMinutes}:${formattedSeconds}`;
    if (hours > 0) {
      const formattedHours = hours.toString().padStart(2, '0');
      formattedTime = `${formattedHours}:${formattedTime}`;
    }

    return formattedTime;
  }
  return time;
}
